function sliderTestimonials() {
  [...document.querySelectorAll('.slider-wrapper-testimonials .splide')]?.forEach(sliderTestimonial => {
    let splideInstanceTestimonials;

    const wrapper = sliderTestimonial.closest('.slider-wrapper-testimonials');
    const mobileSpeed = parseInt(wrapper.dataset.mobileSpeed) || 1000;
    const desktopSpeed = parseInt(wrapper.dataset.desktopSpeed) || 1000;

    const initSliderTestimonial = () => {
      const windowWidth = window.innerWidth;
      const type = windowWidth < 1024 ? 'fade' : 'slide';

      if (splideInstanceTestimonials) {
        splideInstanceTestimonials.destroy();
      }

      splideInstanceTestimonials = new Splide(sliderTestimonial, {
        type: type,
        speed: window.innerWidth < 1024 ? mobileSpeed : desktopSpeed,
        perPage: 1,
        perMove: 1,
        gap: '1.5rem',
        autoHeight: true,
        lazyload: 'sequential',
        rewind: true,
        mediaQuery: 'min',
        pagination: true,
        autoplay: true,
        pauseOnHover: false,
        pauseOnFocus: false,
        interval: 7000,
        focusableNodes: true,
        easing: 'linear',
        breakpoints: {
          1024: {
            type: 'slide',
            perPage: 1,
            perMove: 1,
            pagination: false,
            fixedWidth: '54.6875rem',
            autoplay: false,
            rewind: false,
            easing: 'cubic-bezier(0.25, 1, 0.5, 1)'
          },
          1366: {
            fixedWidth: '46.375rem',
          }
        },
      }
    );

    splideInstanceTestimonials.on( 'move', function (newIndex, prevIndex, destIndex) {
      const slides = sliderTestimonial.querySelectorAll('.splide__slide');
      const direction = (newIndex > prevIndex) ? 'right' : 'left';
        
      slides.forEach(function(splideInstanceTestimonials, index) {
        if (index < destIndex) {
          splideInstanceTestimonials.classList.add('fade-out');
        } else {
          splideInstanceTestimonials.classList.remove('fade-out');
        }
      });
    });

      splideInstanceTestimonials.mount();
    };

    initSliderTestimonial();
    window.addEventListener('resize', initSliderTestimonial);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  sliderTestimonials();
});
